export const SET_GDPR = 'iron/clientLocale/SET_GDPR';
export const SET_COUNTRY_CODE = 'iron/clientLocale/SET_COUNTRY_CODE';
export const SET_BROWSER_LANGUAGE = 'iron/clientLocale/SET_BROWSER_LANGUAGE';

export const setGDPR = (isGDPR) => ({
  type: SET_GDPR,
  payload: { isGDPR },
});
